import LocalizedStrings from 'localized-strings';

import { ReasonCompetitionStep } from '../../constants';

const locales = new LocalizedStrings({
  en: {
    title: 'Have you found an offer elsewhere that suits you better?',
    [ReasonCompetitionStep.Yes]: 'Yes',
    [ReasonCompetitionStep.No]: 'No',
  },
  fr: {
    title: 'Avez-vous trouvé une offre ailleurs qui vous convient davantage ?',
    [ReasonCompetitionStep.Yes]: 'Oui',
    [ReasonCompetitionStep.No]: 'Non',
  },
});

export default locales;
